import { Setting } from '../index';

const bindPhone = {
  methods: {
    // 获取微信手机号
    getUserPhone(e) {
      return new Promise((resolve, reject) => {
        if (e.detail.errMsg === 'getPhoneNumber:ok') {
          console.log('获取用户手机号码成功', e);
          this.handleUpdateProfile({
            bindData: e.detail.encryptedData,
            bindDataSign: e.detail.iv,
          }).then(() => {
            resolve('getPhoneNumber:ok');
          });
        } else {
          reject('getPhoneNumber:failed');
        }
      });
    },
    // 更新用户第三方资料
    async handleUpdateProfile({ bindData, bindDataSign }) {
      const { dispatch } = this.$store;
      const params = {
        form: {
          bindApp: 'wx_miniapp',
          bindKey: Setting.appId,
          bindData,
          bindDataSign,
        },
      };
      await dispatch('user/updateBindProfile', params);
    },
  },
};
export default bindPhone;
